import React, { useEffect, useState } from 'react';
import Button from "components/CustomButtons/Button.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import { Modal, Form, Col } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import useAuth from "hooks/useAuth"
import PhoneInput from 'react-phone-number-input'


import api from "assets/services/api";


function ModalUpdateContacts(props) {

    const { storageId } = useAuth();

    const [br, setBR] = useState(false);
    const [email, setEmail] = useState("");
    const [number, setNumber] = useState("");
    const [name, setName] = useState("");
    const [type, setType] = useState("");
    const [id_client, setId_client] = useState("")
    const [controlSnack, setControlSnack] = useState(false);


    const showNotification = place => {
        switch (place) {
            case "br":
                if (!br) {
                    setBR(true);
                    setTimeout(function () {
                        setBR(false);
                        setControlSnack(false);
                    }, 6000);
                }
                break;
            default:
                break;
        }
    };

    useEffect(() => {
        props.props[0] ? setEmail(props.props[0].email) : setEmail("")
        props.props[0] ? setName(props.props[0].name) : setName("")
        props.props[0] ? setNumber(props.props[0].number) : setNumber("")
        props.props[0] ? setId_client(props.props[0].id_client) : setId_client("")
        props.props[0] ? setType(props.props[0].type) : setType("")
        
    }, []);

    useEffect(() => {
        if (controlSnack) showNotification("br")
    }, [controlSnack]);



    async function handleUpdateContacts(e) {
        e.preventDefault();
        const response = await api.put('/client/contact', {
            name:name,
            number:number,
            type:type,
            email:email,
            id_client:id_client
        });
        if (response.data.error) {
            return alert(response.data.error);
        }

        setName("")
        setNumber("")
        setEmail("")
        setControlSnack(true);
        props.loadContacts();
        props.onHide();


    }

    return (
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Editar contato {props.props.name}
                </Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleUpdateContacts}>
                <Modal.Body>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridBox">
                            <Form.Label>Nome</Form.Label>
                            <Form.Control onChange={event => setName(event.target.value)} value={name} type="string" placeholder="Nome" />
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridBox">
                            <PhoneInput
                                defaultCountry="BR"
                                className="form-control"
                                placeholder="Contato compras"
                                value={number}
                                onChange={(phoneNumber) => {
                                    setNumber(phoneNumber)
                                }}
                            />
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridBox">
                            <Form.Label>Email</Form.Label>
                            <Form.Control onChange={event => setEmail(event.target.value)} value={email} type="string" placeholder="Email" />
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridBox">
                            <Form.Label>Tipo</Form.Label>
                            <Form.Control onChange={()=>{}} value={type} type="string" placeholder="Tipo" disabled />
                        </Form.Group>
                    </Form.Row>

                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex justify-content-center">
                        <Button color="success" type="submit">
                            EDITAR
                        </Button>
                        <Snackbar
                            place="br"
                            color="success"
                            icon={AddAlert}
                            message="Contato atualizado com sucesso"
                            open={br}
                            closeNotification={() => setBR(false)}
                            close
                        />
                    </div>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

export default ModalUpdateContacts;